import './back.scss';

// Assets
import { ReactComponent as BackIcon } from '../../asset/back.svg';
import { useHistory } from 'react-router-dom';

const Back = () => {
	const history = useHistory();

	return (
		<div className="back" onClick={() => history.push('/')}>
			<BackIcon />
		</div>
	);
};

export default Back;
